import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ArrowUpIcon from "../Icons/ArrowUpIcon";
import { sanitize } from "dompurify";
import { QuestionType } from "@fhc/shared/constants";

const AssessmentSummary = ({ questions, responses }) => {
    return (
        <Accordion slotProps={{heading: { component: 'h2' }}} className="rounded-t-lg w-full bg-transparent text-white border-none shadow-none">
            <AccordionSummary aria-controls="panel2a-content" id="panel2a-header">
                <div className="flex items-start space-x-[20px] md:space-x-[40px] xl:space-x-[55.5px]">
                    <ArrowUpIcon color="white" opacity="1"></ArrowUpIcon>
                    <div className="">
                        <div className="header-text text-[30px] leading-10 md:text-[48px] mb-[15px] font-semibold">
                            Summary of your assessment
                        </div>
                        <div className="body-text font-normal text-[18pt]">Review your responses</div>
                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <div className="ml-12 md:ml-14 xl:ml-24">
                    {questions.map((question, i) => (
                        <div key={i} className="mb-[23px]">
                            <div className="header-text font-bold text-[14pt]">
                                Q{i + 1}. <span dangerouslySetInnerHTML={{ __html: sanitize(question.question) }} />
                            </div>
                            <div className="body-text font-normal ml-5 text-[18pt]">
                                {responses[question.id] ? (
                                question.type == QuestionType.TEXTBOX || question.type == QuestionType.RATING_SCALE ? (
                                    responses[question.id]
                                ) : question.type === QuestionType.SINGLE_RESPONSE ? (
                                    Object.values(responses[question.id])[0].label
                                ) : question.type == QuestionType.MULTIPLE_RESPONSE ||
                                  question.type === QuestionType.MATRIX ? (
                                    <div className="space-x-2">
                                        {Object.values(responses[question.id]).map((res, i) => (
                                            <div className="font-normal" key={i}>
                                                - {res.label}
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    Object.values(responses[question.id]).label
                                )) : (
                                    <div className="font-normal" key={i}>
                                        None
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </AccordionDetails>
        </Accordion>
    );
};
export default AssessmentSummary;
